/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetOfferPinPopupRequest, TGetOfferPinPopupModel, IMappers, TGetOfferPinPopupResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetOfferPinPopupForMapResponseSchema } from '../../entities/entities/GetOfferPinPopupForMapResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetOfferPinPopupModel(parameters: TGetOfferPinPopupRequest): TGetOfferPinPopupModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'countryside-search',
    pathApi: '/v1/get-offer-pin-popup/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetOfferPinPopupOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetOfferPinPopupRequest;
}

export async function fetchGetOfferPinPopup<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOfferPinPopupOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetOfferPinPopupResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetOfferPinPopupModel(parameters),
    config,
  )) as FetchResponse<TGetOfferPinPopupResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetOfferPinPopupForMapResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetOfferPinPopupResponse>;
}
